import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import { TruncatedTextWithTooltip } from '../../molecules/TruncatedTextWithTooltip'
import EditButton from '../../molecules/buttons/EditButton'
import DeleteButton from '../../molecules/buttons/DeleteButton'
import Table from '../../atoms/table/Table'
import Tr from '../../atoms/table/Tr'
import Th from '../../atoms/table/Th'
import Td from '../../atoms/table/Td'
import TranslateButton from '../../molecules/buttons/TranslateButton'
import UserInfoTable from './UserInfoTable'

const ProcedureManagementsTable = ({ procedureManagements = [], onDestroy }) => {
  return (
    <div className="pt-8 pb-2">
      <Table
        className="table-fixed lg:w-full"
        values={procedureManagements}
        head={
          <Tr body={false}>
            <Th className="w-4">ID</Th>
            <Th>Nombre</Th>
            <Th className="w-64">Creación</Th>
            <Th className="w-64">Actualización</Th>
            <Th className="w-36">Publicación</Th>
            <Th>Idiomas</Th>
            <Th>Acciones</Th>
          </Tr>
        }
        body={procedureManagements.map(row => (
          <Tr key={row.id}>
            <Td>{row.id}</Td>
            <Td>
              <TruncatedTextWithTooltip text={row.name}>
                {props => (
                  <Link to={`/gestiones-de-tramites/${row.id}/vista-previa`} {...props}>
                    {row.name}
                  </Link>
                )}
              </TruncatedTextWithTooltip>
            </Td>
            <Td>
              <UserInfoTable
                id={row.created_by}
                name={row.creator_name}
                eliminatorName={row.creator_eliminator_name}
                eliminatedName={row.eliminated_creator_name}
                date={row.date_created_at}
                hour={row.hour_created_at}
                hasHour
              />
            </Td>
            <Td>
              <UserInfoTable
                id={row.updated_by}
                name={row.updater_name}
                eliminatorName={row.updater_eliminator_name}
                eliminatedName={row.eliminated_updater_name}
                date={row.date_updated_at}
                hour={row.hour_updated_at}
                hasHour
              />
            </Td>
            <Td>{row.published ? 'Publicado' : 'No publicado'}</Td>
            <Td>{row.languages}</Td>
            <Td>
              <EditButton to={`/gestiones-de-tramites/${row.id}/editar`} />
              <TranslateButton to={`/gestiones-de-tramites/${row.id}/traducciones`} />
              <DeleteButton onClick={() => onDestroy(row)} />
            </Td>
          </Tr>
        ))}
      />
    </div>
  )
}

export default ProcedureManagementsTable

ProcedureManagementsTable.propTypes = {
  onDestroy: PropTypes.func.isRequired,
  procedureManagements: PropTypes.arrayOf(PropTypes.object)
}
